import FormFieldScale from './FormFieldScale';

export default FormFieldScale;
